/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 React examples
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";

// Presentation page sections
import Counters from "pages/Presentation/sections/Counters";
import Information from "pages/Presentation/sections/Information";
import DesignBlocks from "pages/Presentation/sections/DesignBlocks";
import Testimonials from "pages/Presentation/sections/Testimonials";

// Presentation page components
// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

// Images
import bgImage from "assets/images/bg-presentation.jpg";

function Presentation() {
  return (
    <>
      <div id="acceuil"></div>
      <DefaultNavbar routes={routes} sticky />
      <MKBox
        minHeight="75vh"
        width="100%"
        sx={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "top",
          display: "grid",
          placeItems: "center",
        }}
      >
        <Container>
          <Grid container item xs={12} lg={7} justifyContent="center" textAlign="center" mx="auto">
            <MKTypography
              variant="h1"
              color="white"
              mt={-6}
              mb={1}
              ml={2}
              sx={({ breakpoints, typography: { size } }) => ({
                [breakpoints.down("md")]: {
                  fontSize: size["3xl"],
                },
              })}
            >
              L&apos;Évènementiel d&apos;Exception{" "}
            </MKTypography>
            <MKTypography
              variant="body1"
              color="white"
              textAlign="center"
              px={{ xs: 12, lg: 12 }}
              mt={1}
            >
              Votre Évènement, Notre Passion..
            </MKTypography>
          </Grid>
        </Container>
      </MKBox>
      <Card
        sx={{
          p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
          backdropFilter: "saturate(200%) blur(30px)",
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <div
          style={{
            width: "100%",
            padding: "24px",
            borderRadius: "12px",
            backgroundColor: "#f5f5f5",
            textAlign: "center",
          }}
        >
          <h3>A PROPOS DE ANEMAR GROUPE</h3>
          <p>
            <strong>
              Chez ANEMAR GROUPE, nous transformons chaque évènement en une expérience unique et
              inoubliable. Spécialisés dans l&apos;organisation d&apos;évènements sur mesure, nous
              mettons notre expertise et notre passion au service de vos projets, qu&apos;il
              s&apos;agisse de mariages enchanteurs, de conférences professionnelles, de lancements
              de produits captivants ou de fêtes privées. Notre mission est simple : créer des
              souvenirs mémorables en donnant vie à vos idées.À l&apos;écoute de vos besoins et de
              vos envies, notre équipe dédiée conçoit des évènements personnalisés qui reflètent
              votre style et votre identité. la planification à la réalisation, nous gérons chaque
              détail avec précision et créativité, vous permettant ainsi de profiter pleinement de
              votre moment sans le moindre stress.
            </strong>
          </p>
        </div>
        <div id="activites">
          <Counters />
        </div>
        <div>
          <Information />
        </div>
        <div id="realisations">
          <DesignBlocks />
        </div>
        <div id="contacts">
          <Testimonials />
        </div>
      </Card>
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default Presentation;
